/** @format */

import { Row, Col, Dropdown, Menu } from "antd";
import React from "react";
import { Routes } from "../../utils/Routes";
import { UILink } from "../../components/ui/Link";
import { EditOutlined, MoreOutlined } from "@ant-design/icons";
import { useHistory } from "react-router";
import { UIText } from "../../components/ui/Text";
import { BaseColor } from "../../theme/maps/Colors";
import { useSelector } from "react-redux";
import { selectorPermissionList } from "../../redux-modules/selectors/selectorsPermissions";
import { hasPermission } from "../../utils/permissions/hasPermission";

export const deviceListColumns = [
  { title: "#", dataIndex: "id", key: "id", showMobile: true },
  {
    title: "Sede",
    dataIndex: "office_name",
    key: "office_name",
    showMobile: true,
  },
  {
    title: "Codice iPad",
    dataIndex: "code",
    key: "code",
    showMobile: true,
  },
  {
    title: "Codice NFC",
    dataIndex: "nfc_code",
    key: "nfc_code",
    showMobile: true,
  },
  {
    title: "Azioni",
    dataIndex: "actions",
    key: "actions",
    showMobile: true,
    //@ts-ignore
    // eslint-disable-next-line react/display-name
    render: (text, row, index): JSX.Element => (
      <ActionDropdown text={text} row={row} index={index} />
    ),
  },
];

//@ts-ignore
const ActionDropdown = ({ text, row, index }): JSX.Element => {
  const history = useHistory();
  const permissionList = useSelector(selectorPermissionList);

  const menu = (
    <Menu>
      <Menu.Item
        key="1"
        onClick={() => history.push(Routes.devicesEdit.replace(":id_device", row.id))}
        icon={<EditOutlined />}
      >
        Gestisci
      </Menu.Item>
    </Menu>
  );

  if (!hasPermission(permissionList, "Device", "Update")) return <></>;
  return (
    <>
      <Dropdown overlay={menu}>
        <UIText css={"font-size: 24px; cursor: pointer;"} color={BaseColor}>
          <MoreOutlined />
        </UIText>
      </Dropdown>
    </>
  );
};
